import React from "react";
import { useTranslation } from "react-i18next";

import desktopImg from "../../img/AboutUs/rec4.webp";
import mobileImg from "../../img/AboutUs/rec4.webp";
import Fade from 'react-reveal/Fade';

function EducationDark() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* Desktop */}
      <div className="hidden xl:block">
        <div className="relative mx-auto h-[435px] max-w-[1220px] overflow-hidden bg-[#05193a]">
          {/* Right image */}
          <div className="absolute right-0 top-0 h-[435px] w-[592px] overflow-hidden">
            <img src={desktopImg} alt="" className="h-full w-full object-cover" />
          </div>
          {/* Left text */}
          <Fade bottom>
          <div className="absolute left-[46px] top-[55px] flex w-[443px] flex-col gap-[20px]">
            <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] text-[#daebfc]">
              {t("about.education.title")}
            </h2>
            <span className="block h-[4px] w-[104px] bg-[#daebfc]" />
            <div className="flex flex-col gap-[15px]">
              <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-white">
                {t("about.education.text1")}
              </p>
              <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-white">
                {t("about.education.text2")}
              </p>
            </div>
          </div>
          </Fade>
        </div>
      </div>

      {/* Mobile */}
      <div className="xl:hidden">
        <div className="overflow-hidden">
          <img src={mobileImg} alt="" className="h-[185px] w-full object-cover" />
        </div>
        <Fade bottom>
        <div className="bg-[#05193a] px-[20px] pb-[40px] pt-[30px]">
          <div className="flex flex-col gap-[15px]">
            <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#daebfc]">
              {t("about.education.title")}
            </h2>
            <span className="block h-[4px] w-[104px] bg-[#daebfc]" />
            <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-white">
              {t("about.education.text1")}
            </p>
            <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-white">
              {t("about.education.text2")}
            </p>
          </div>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default EducationDark;
